import { Banner } from '@servicetitan/design-system';
import { ReactNode } from 'react';

type Props = {
  title: string;
  show: boolean;
  onRetry?: () => void;
  children?: ReactNode;
  className?: string;
};

const PageError = ({ title, show, onRetry, children, className }: Props) => {
  const handleRetry = () => {
    if (onRetry) {
      onRetry();
    }
  };

  if (!show) {
    return null;
  }

  return (
    <Banner
      status='critical'
      title={title}
      show={true}
      secondaryActionName={onRetry ? 'Retry' : undefined}
      onSecondaryActionClick={handleRetry}
      style={{ marginBottom: 20 }}
      className={className}
    >
      {children}
    </Banner>
  );
};

export default PageError;
